export enum FORM_MULTI_TEXT_TYPES {
  ADDRESS = 'ADDRESS',
  NAME_ADDRESS = 'NAME_ADDRESS',
  PHONE = 'PHONE'
}

export enum FORM_MULTI_TEXT_LAYOUT {
  ROW = 'ROW',
  COLUMN = 'COLUMN'
}

export const FORM_MULTI_TEXT_COMPONENT_TYPES = {
  ADDRESS: {
    title: 'What is your address?',
    registerAs: [
      // 'country',
      'line1',
      'line2',
      'city'
    ],
    requiredMessage: 'Please add your address',
    pattern: [/^[a-zA-Z0-9\s,.'-]{3,}$/, /^[a-zA-Z0-9\s,.'-]{3,}$/, /^[a-zA-Z0-9\s,.'-]{3,}$/, /^[a-zA-Z0-9\s,.'-]{3,}$/],
    patternMessage: 'Please enter a valid address',
    placeholder: [
      // 'Country',
      'Address Line 1',
      'Address Line 2',
      'City'
    ],
    optionalFields: ['line2'],
    layout: FORM_MULTI_TEXT_LAYOUT.COLUMN,
    widths: [
      // undefined,
      undefined,
      undefined,
      undefined
    ],
    enabledFields: ['line1', 'line2', 'city'],
    defaultValues: [
      // 'United Kingdom',
      undefined,
      undefined,
      undefined
    ]
  },
  NAME_ADDRESS: {
    title: 'Please enter the name and address',
    registerAs: ['name', 'address.country', 'address.line1', 'address.line2', 'address.city'],
    requiredMessage: 'Please add the name and address',
    pattern: [undefined, undefined, /^[a-zA-Z0-9\s,.'-]{3,}$/, /^[a-zA-Z0-9\s,.'-]{3,}$/, /^[a-zA-Z0-9\s,.'-]{3,}$/],
    patternMessage: 'Please enter a valid address',
    placeholder: ['Name', 'Country', 'Address Line 1', 'Address Line 2', 'City'],
    optionalFields: ['name', 'address.country', 'address.line1', 'address.line2', 'address.city'],
    layout: FORM_MULTI_TEXT_LAYOUT.COLUMN,
    widths: [undefined, undefined, undefined, undefined, undefined],
    enabledFields: ['name', 'address.country', 'address.line1', 'address.line2', 'address.city'],
    defaultValues: [undefined, undefined, undefined, undefined, undefined]
  },
  PHONE: {
    title: 'What is your phone number?',
    registerAs: ['country_code', 'number'],
    requiredMessage: 'Please add your phone number',
    // FOR NOW TODO: LIBRARY (THHAT WASSIM DOESNT WANT FOR SOME REASON)
    pattern: [undefined, undefined],
    patternMessage: 'Please enter a valid phone number',
    placeholder: ['+', 'Phone Number'],
    optionalFields: ['country_code'],
    layout: FORM_MULTI_TEXT_LAYOUT.ROW,
    widths: [40, undefined],
    enabledFields: ['country_code', 'number'],
    defaultValues: [undefined, undefined]
  }
} as const;
